<h2 mat-dialog-title>{{ 'MAP.TRIAL_OVER' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <p>{{ 'MAP.TRIAL_OVER_MSG' | translate }}</p>
  <p>
    {{ 'MAP.TRIAL_OVER_CONTACT' | translate }}
    <a href="mailto:contato@umgrauemeio.com" target="_blank">contato&#64;umgrauemeio.com</a>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'MAP.CLOSE' | translate }}</button>
</mat-dialog-actions>
